import { render, staticRenderFns } from "./AdContent.vue?vue&type=template&id=d632ca48&scoped=true&"
import script from "./AdContent.vue?vue&type=script&lang=js&"
export * from "./AdContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d632ca48",
  null
  
)

export default component.exports